export default {
	properties: [
		{
			text: 'Nombre',
			key: 'name',
			type: 'text',
		},
	],
	singular_model_name_spanish: 'Tipo de Propiedad de Articulo',
	plural_model_name_spanish: 'Tipos de Propiedad de Articulo',
	create_model_name_spanish: 'Nuevo',
	text_delete: 'el',
}